module.exports = new __parcel__URL__("vijayanand.ffa35fc4.png").toString();